import { PoweroffOutlined, UserOutlined } from "@ant-design/icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { ReactElement } from "react";
import { connect } from "react-redux";
import { logout } from "../../../utils/auth";

const TopHeader = ({ userName }: any): ReactElement => {
  return (
    <div className="top-header-area">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="admin-information-sidebar">
              <ul>
                <li className="has-dropdown">
                  <UserOutlined />
                  <span className="text-capitalize">{userName}</span>
                  <FontAwesomeIcon icon={faAngleDown}></FontAwesomeIcon>
                  <ul className="drop-down-menu">
                    {/* <li>
                        <Link to="/setting">Settings</Link>
                      </li>
                      <li>
                        <Link to="/information">Account Information</Link>
                      </li> */}
                    <li>
                      <button onClick={() => logout("/login")}>
                        <PoweroffOutlined className="text-danger" /> Logout
                      </button>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
TopHeader.propTypes = {
  userName: PropTypes.string,
};
const mapStateTopProps = (state: {
  authReducer: { name: string; email: string };
}) => {
  return {
    userName:
      state.authReducer.name || state.authReducer?.email?.split("@")?.[0],
  };
};
export default connect(mapStateTopProps, null)(TopHeader);
